

export const enum FilterRecursosCostumizados {
    NAO_INICIADOS = 'NAO_INICIADOS',
    INICIADOS = 'INICIADOS',
    FINALIZADOS = 'FINALIZADOS',
    TODOS = 'TODOS'
}